import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { Component, useEffect, useRef, useState } from 'react';
import dnsImage from './resources/images/dns.png';
import kycImage from './resources/images/kyc.png';
import linkedinImage from './resources/images/linkedin.png';
import failureImage from './resources/images/failure.png';
import successImage from './resources/images/success.png';
import trashImage from './resources/images/trash.png';
import CompleteVerification from './ui/CompleteVerification';

const images = {
    DNS: dnsImage,
    KYC: kycImage,
    LINKEDIN: linkedinImage,
};

class Proof extends Component {
    state = {
        valid: '...',
        expect: '...',
        location: '...',
    };

    async componentDidMount() {
        return this.props.library.validate(this.props.proof).then((result) => {
            this.setState({
                valid: result.valid?.toString(),
                expect: this.props.proof.expect,
                location: result.location,
            });
            this.props.onValidated(result.valid);
        });
    }

    render() {
        const proof = this.props.proof;
        const resource = proof.platform === 'KYC' ? `${proof.method} verified` : decodeURI(proof.resource);
        const clickPrimary = (proof, valid, location) => this.props.onClick['primary'](proof, valid, location);
        const clickSecondary = (proof, valid, location) => this.props.onClick['secondary'](proof, valid, location);
        return (
            proof.active &&
            this.props.visible && (
                <>
                    <div>
                        <Stack mt={1} direction={'row'} spacing={1} alignItems={'center'}>
                            <Stack direction={'row'} spacing={1} style={{ cursor: 'pointer' }}>
                                <Stack onClick={() => clickSecondary(proof, this.state.valid, this.state.location)}>
                                    <img
                                        src={images[proof.platform]}
                                        alt={proof.platform}
                                        height={'24px'}
                                        width={'24px'}
                                    />
                                </Stack>
                                <Stack onClick={() => clickSecondary(proof, this.state.valid, this.state.location)}>
                                    <Typography sx={{ color: '#548CFF', fontWeight: 700 }} variant="body1">
                                        {resource}
                                    </Typography>
                                </Stack>

                                {this.props.showInvalid ? (
                                    <>
                                        <Stack
                                            onClick={() => clickPrimary(proof, this.state.valid, this.state.location)}
                                        >
                                            <img
                                                src={this.state.valid === 'true' ? successImage : failureImage}
                                                alt="verified"
                                            />
                                        </Stack>
                                        <Stack
                                            direction={'column'}
                                            onClick={() => clickPrimary(proof, this.state.valid, this.state.location)}
                                        >
                                            <Typography sx={{ color: '#548CFF', pt: '2px' }} variant="body2">
                                                {proof.platform.toLowerCase()}
                                            </Typography>
                                        </Stack>
                                    </>
                                ) : this.state.valid === 'true' ? (
                                    <Stack
                                        direction={'column'}
                                        onClick={() => clickPrimary(proof, this.state.valid, this.state.location)}
                                    >
                                        <img src={successImage} alt="verified" />
                                    </Stack>
                                ) : (
                                    <Stack
                                        direction={'column'}
                                        onClick={() => clickPrimary(proof, this.state.valid, this.state.location)}
                                    >
                                        <CompleteVerification title={this.props.completeVerificationTitle} />
                                    </Stack>
                                )}
                            </Stack>
                            {!this.props.showInvalid && this.props.role === 'ADMIN' && (
                                <img
                                    src={trashImage}
                                    height={'20px'}
                                    style={{ cursor: 'pointer' }}
                                    width={'20px'}
                                    onClick={this.props.onDrop}
                                    alt={'delete'}
                                />
                            )}
                        </Stack>
                    </div>
                </>
            )
        );
    }
}

export default function ProofList(properties) {
    const [proofs, setProofs] = useState([]);
    const [hiddenIndexes, setHiddenIndexes] = useState([]);
    const proofsData = useRef([]);
    const validatedProofs = useRef([]);
    const handleInvalid = (index, valid) => {
        if (validatedProofs.current.find((x) => x.index === index) !== undefined) return;
        validatedProofs.current.push({ valid: valid, index: index });
        if (
            properties.onInvalid &&
            validatedProofs.current.length === proofsData.current.length &&
            !validatedProofs.current.find((x) => x.valid)
        )
            properties.onInvalid();
    };

    const handleDrop = (index) => {
        setHiddenIndexes(hiddenIndexes.concat(index));
        return properties.onDrop ? properties.onDrop(index) : null;
    };

    const refreshProofs = async () =>
        Promise.resolve(() => setProofs([])).then(async () =>
            (properties.proofLoader
                ? properties.proofLoader(properties.address.current)
                : properties.library.proofsOf(properties.address.current)
            )
                .then((proofs) => (proofsData.current = proofs))
                .then((proofs) => {
                    properties.proofsLoaded ? properties.proofsLoaded(proofs) : null;
                    return proofs;
                })
                .then((data) => {
                    properties.proofsInProcess
                        ?.filter((e) => data.find((p) => e.platform === p.platform && e.resource === p.resource))
                        .map((e) => {
                            e.onProcessed(e.platform, e.resource);
                        });
                    return data;
                })
                .then((data) =>
                    data.map((each, index) => (
                        <Proof
                            library={properties.library}
                            proof={each}
                            key={index}
                            showInvalid={properties.showInvalid}
                            onValidated={(valid) => handleInvalid(index, valid)}
                            onClick={properties.onClick}
                            onDrop={() => handleDrop(index)}
                            completeVerificationTitle={properties.completeVerificationTitle ?? 'Complete verification'}
                            role={properties.role}
                            visible={hiddenIndexes.indexOf(index) === -1}
                        />
                    )),
                )
                .then((rows) => setProofs([rows])),
        );

    useEffect(() => {
        void refreshProofs();
    }, [properties.address]);

    return <div>{proofs}</div>;
}
